<ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav nav-pills">

  <li *ngFor="let tab of tabs" [ngbNavItem]="tab.id">
    <button ngbNavLink>{{ tab.title }}</button>

    <ng-template ngbNavContent>
      <ng-container *ngTemplateOutlet="tab.content"></ng-container>
    </ng-template>
  </li>

</ul>

<div [ngbNavOutlet]="nav"></div>